import { REWARD_TYPES } from '__constants__'

const getRewardDataField = (rewardType) => {
  return rewardType === REWARD_TYPES.EMAIL
    ? ['email', 'address']
    : ['address', 'email']
}

export default getRewardDataField
